<template>
  <div>
    <navbar></navbar>
    <notifications></notifications>
    <div class="container-fluid workspace-wrapper">
      <div ref="workspace" class="workspace">
        <div class="loading" v-if="loading">
          <icon name="spinner" class="fa-spin"></icon>
        </div>
        <vue-draggable-resizable class="window-wrapper"
                                 v-if="!loading"
                                 v-for="window in windows" :key="window.windowId"
                                 @dragging="(x,y) => onDragged(window.windowId, x, y)"
                                 @resizing="(x,y,w,h) => onResized(window.windowId, x, y, w, h)"
                                 :w="window.data.w || defaultWidth" :minw="200"
                                 :h="window.data.h || defaultHeight" :minh="40"
                                 :x="getWindowX(window)"
                                 :y="getWindowY(window)"
                                 :zIndex="window.data.zIndex"
                                 :parent="true" :grid="[5, 5]"
                                 @activated="() => activated(window.windowId)">
          <component class="window-container" :is="window.componentType" :window-id="window.windowId"></component>
        </vue-draggable-resizable>
      </div>
    </div>
    <datalist id="folders">
      <option v-for="folder in folders" :value="folder"></option>
    </datalist>
  </div>
</template>

<script>
  import _ from 'lodash'
  import Navbar from './navbar'
  import Notifications from './notifications'
  import VueDraggableResizable from './vue-draggable-resizable'
  import * as action from '@/store/action-types'

  export default {
    components: {Navbar, Notifications, VueDraggableResizable},
    name: 'workspace',
    data () {
      return {
        defaultWidth: 400,
        defaultHeight: 300
      }
    },
    computed: {
      folders () {
        return this.$store.getters.folders()
      },
      loading () {
        return this.$store.getters.loading
      },
      windows () {
        return this.$store.getters.windows().filter(w => w.visible)
      }
    },
    mounted () {
      // Prevent page refresh
      this.$shortcut.bind('f5', () => {})
    },
    methods: {
      /**
       * Returns maximum x for a given window with respect to it's dimension and the workspace size
       * @param window
       * @returns {number}
       */
      getWindowX (window) {
        if (!window || !window.data) return 0
        if (!this.$refs.workspace) return window.data.x || 0
        const maxX = this.$refs.workspace.clientWidth - (window.data.w || this.defaultWidth)
        return Math.max(0, Math.min(window.data.x || 0, maxX)) || 0
      },
      /**
       * Returns maximum y for a given window with respect to it's dimension and the workspace size.
       * @param window
       * @returns {number}
       */
      getWindowY (window) {
        if (!window || !window.data) return 0
        if (!this.$refs.workspace) return window.data.y || 0
        const maxY = this.$refs.workspace.clientHeight - (window.data.h || this.defaultHeight)
        return Math.max(0, Math.min(window.data.y || 0, maxY)) || 0
      },
      onResized: _.debounce(function (windowId, x, y, w, h) {
        this.$store.dispatch(action.WINDOW_DATA, {windowId, data: {x, y, w, h}})
      }, 1000),
      onDragged: _.debounce(function (windowId, x, y) {
        this.$store.dispatch(action.WINDOW_DATA, {windowId, data: {x, y}})
      }, 1000),
      activated: function (windowId) {
        this.$shortcut.setContext(windowId)
        this.$store.dispatch(action.WINDOW_ACTIVATE, {windowId})
      }
    }
  }
</script>

<style lang="scss">
  .loading {
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    position: fixed;
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    color: #555;
  }

  .workspace-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    padding: 56px 0 0;
    height: 100vh;
    width: 100vw;
  }

  .workspace {
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  .window-wrapper {
    position: absolute;
    top: 100px;
    left: 100px;
    box-shadow: 0 20px 32px -8px rgba(9, 45, 66, .25);
  }

  .window-container {
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  div.tabs {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  div.tab-content {
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    width: 100%;
  }

  .tab-pane {
    height: 100%;
    width: 100%;
  }

  .fa-icon {
    width: auto;
    height: 1em;
    margin-bottom: -0.2em
  }

  .vdr-handle-active a:hover {
    cursor: move;
  }

  .handle {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/layout/workspace.vue